import { render, staticRenderFns } from "./TopicoFormularioAvaliativo.vue?vue&type=template&id=38a2a6ef&scoped=true"
import script from "./TopicoFormularioAvaliativo.vue?vue&type=script&lang=js"
export * from "./TopicoFormularioAvaliativo.vue?vue&type=script&lang=js"
import style0 from "./TopicoFormularioAvaliativo.vue?vue&type=style&index=0&id=38a2a6ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a2a6ef",
  null
  
)

export default component.exports